import {WicketUser} from '@tisa-group/models';

export function mapUserDataResponseToUser(user: WicketUser): WicketUser {
  user.club_id = isNaN(Number(user.club_id)) ? undefined : Number(user.club_id);

  return user;
}
